import React, { FC } from 'react';
import clsx from 'clsx';
import { Heading, Types } from '@marriott/mi-ui-library';

import { PointsWrapperHeaderProps } from './PointsWrapper.types';

export const PointsWrapperHeader: FC<PointsWrapperHeaderProps> = ({ id, header, headerTag, headerFontSize }) => {
  if (!header) return null;

  const resolvedHeaderTag = (headerTag as Types.tags) || Types.tags.h2;
  const headerFontSizeClass = headerFontSize || 't-title-s';

  return (
    <div className="pointswrapper__intro">
      {header && (
        <Heading
          element={resolvedHeaderTag}
          variation={Types.headingType.title}
          fontSize={Types.size.small}
          customClass={clsx('pointswrapper__header mb-4 mb-md-5 pb-md-3 mb-lg-4 pb-lg-0', headerFontSizeClass)}
          titleText={header}
          {...(id ? { id } : {})}
        />
      )}
    </div>
  );
};
